import Vue from "vue";
import store from "../store";
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    localize
} from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

extend("required", required);
extend("email", email);

// localize({
//     en,
//     es
// });

localize({
    en: {
        messages: en.messages,

        names: {
            name: "name",
            email: "email",
            password: "password",
            promo_code: "promo code",
            message: "message",
            username: "username",
            payment_methods: "payment methods",
            country: "country",
            name_on_card: "name",
            card_number: "card number",
            card_expiry_month: "expiry month",
            card_expiry_year: "expiry year",
            cvv: "cvv",
            zip_code: "zip code"
        }
    },

    es: {
        messages: es.messages,

        names: {
            name: "nombre",
            email: "correo",
            password: "contraeña",
            promo_code: "código promocional",
            message: "mensaje",
            username: "usuario",
            payment_methods: "métodos de pago",
            country: "país",
            name_on_card: "nombre",
            card_number: "número de tarjeta",
            card_expiry_month: "mes de vencimiento",
            card_expiry_year: "año de vencimiento",
            cvv: "cvv",
            zip_code: "código postal"
        }
    }
});

localize(store.state.lang);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
